export enum TabType {
    TO_PROCESS,
    PROCESSED
}